import { Component } from 'react';
import type { RelayRefetchProp } from 'react-relay';
import { createRefetchContainer, graphql } from 'react-relay';

import { ResourceSelectField } from '@feedback/select';

import type { JobExamAnswerSelectField_query } from './__generated__/JobExamAnswerSelectField_query.graphql';

type JobExamAnswer = {
  id: string;
  title: string;
};

type Props = {
  query: JobExamAnswerSelectField_query;
  multiple?: boolean;
  onChange: (node: any) => void;
  relay: RelayRefetchProp;
  hintText?: string | null;
  displayUnderline?: boolean | null;
  fullWidth?: boolean;
  value?: JobExamAnswer;
};

type State = {
  input: string;
  search: string;
};

class JobExamAnswerSelectField extends Component<Props, State> {
  static defaultProps = {
    hintText: 'Buscar resposta da questão',
    name: 'jobExam.answer',
  };

  componentDidUpdate(prevProps) {
    if (
      this.props?.values?.jobExam?.question != null &&
      this.props?.values?.jobExam?.question !==
        prevProps?.values?.jobExam?.question
    ) {
      const refetchVariables = (fragmentVariables) => ({
        ...fragmentVariables,
        jobExamQuestionId: this.props.values.jobExam.question,
      });

      this.props.relay.refetch(refetchVariables, null, () => {}, {
        force: true,
      });
    }
  }

  getItemFromNode = ({ id, value }) => {
    return {
      id,
      name: value,
    };
  };

  getFilterFragmentVariables = (state) => {
    const { search } = state;

    return {
      search,
    };
  };

  toIdName = (answer) => ({
    id: answer.value,
    value: answer.value,
  });

  getConnection = () => {
    const { query } = this.props;
    const { jobExamQuestion } = query;

    if (!jobExamQuestion) {
      return { count: 0, edges: [] };
    }

    return {
      count: jobExamQuestion.options.length,
      edges: jobExamQuestion.options.map((option) => ({
        node: this.toIdName(option),
      })),
    };
  };

  render() {
    const { query, relay, ...props } = this.props;
    const { jobExamQuestion } = query;

    const emptyMessage = jobExamQuestion
      ? 'Questão não possui respostas'
      : 'Escolha uma questão';

    return (
      <ResourceSelectField
        relay={relay}
        connection={this.getConnection()}
        getItemFromNode={this.getItemFromNode}
        emptyMessage={emptyMessage}
        {...props}
      />
    );
  }
}

const JobExamAnswerSelectFieldRefetchContainer = createRefetchContainer(
  JobExamAnswerSelectField,
  {
    query: graphql`
      fragment JobExamAnswerSelectField_query on Query
      @argumentDefinitions(jobExamQuestionId: { type: ID }) {
        jobExamQuestion: node(id: $jobExamQuestionId) {
          id
          ... on JobExamQuestion {
            id
            options {
              value
            }
          }
        }
      }
    `,
  },
  graphql`
    query JobExamAnswerSelectFieldRefetchQuery($jobExamQuestionId: ID) {
      ...JobExamAnswerSelectField_query
        @arguments(jobExamQuestionId: $jobExamQuestionId)
    }
  `,
);

export default JobExamAnswerSelectFieldRefetchContainer;
